import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCrossCircleBox12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCrossCircleBox12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.5 2h9a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5M0 2.5A1.5 1.5 0 0 1 1.5 1h9A1.5 1.5 0 0 1 12 2.5v7a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 9.5zM8.5 6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m1 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M7.104 4.896a.5.5 0 0 1 0 .708L6.707 6l.397.396a.5.5 0 0 1-.708.708L6 6.707l-.397.397a.5.5 0 1 1-.707-.708L5.293 6l-.397-.396a.5.5 0 1 1 .708-.708L6 5.293l.396-.397a.5.5 0 0 1 .708 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCrossCircleBox12);
